export function cmBooleanPipeLocalizationDefaults(feature: string) {
	const POSITIVE = { defaultValue: 'Yes', key: `${feature}/System.Global.Content.True` };
	const NEGATIVE = { defaultValue: 'No', key: `${feature}/System.Global.Content.False` };
	const INDETERMINATE = { defaultValue: 'N/A', key: `${feature}/_Shared.Global.Content.Na` };
	return { POSITIVE, NEGATIVE, INDETERMINATE };
}
